import { render, staticRenderFns } from "./Detector.vue?vue&type=template&id=3caf1490&scoped=true&"
import script from "./Detector.vue?vue&type=script&lang=js&"
export * from "./Detector.vue?vue&type=script&lang=js&"
import style0 from "./Detector.vue?vue&type=style&index=0&id=3caf1490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caf1490",
  null
  
)

export default component.exports